module.exports = __webpack_public_path__ + "static/img/car_5_2_cold@3x.813c8a1b.png";